import type { ParsedUrlQuery } from 'querystring'

// pharmacy-support-web からの遷移時に account_id で渡される、ログイン中の薬局 UID
// （pharmacy-{admin,store}/src/lib/auth/buildUserSettingsUrl.ts）。本部 UID / 店舗 UID の
// どちらかが入るが URL では区別されないため、種別に依存しない名前で扱う。
export const getLoginPharmacyUid = (query: ParsedUrlQuery): string | null => {
  return typeof query.account_id === 'string' ? query.account_id : null
}
